export default function Timeline({ items = [] }) {
  if (!items.length) {
    return <p className="muted">No timeline items yet.</p>;
  }

  return (
    <ol className="timeline">
      {items.map((item) => (
        <li key={item.id || item.label} className={`timeline-item${item.complete ? " is-complete" : ""}`}>
          <strong>{item.label}</strong>
          {item.detail ? <p className="muted">{item.detail}</p> : null}
        </li>
      ))}
    </ol>
  );
}
